import * as React from 'react'

function SvgCarFrontIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.5607 22.5607C16.2794 22.842 15.8978 23 15.5 23C15.1022 23 14.7206 22.842 14.4393 22.5607C14.158 22.2794 14 21.8978 14 21.5C14 21.1022 14.158 20.7206 14.4393 20.4393C14.7206 20.158 15.1022 20 15.5 20C15.8978 20 16.2794 20.158 16.5607 20.4393C16.842 20.7206 17 21.1022 17 21.5C17 21.8978 16.842 22.2794 16.5607 22.5607Z"
        fill="black"
      />
      <path
        d="M25.5607 22.5607C25.842 22.2794 26 21.8978 26 21.5C26 21.1022 25.842 20.7206 25.5607 20.4393C25.2794 20.158 24.8978 20 24.5 20C24.1022 20 23.7206 20.158 23.4393 20.4393C23.158 20.7206 23 21.1022 23 21.5C23 21.8978 23.158 22.2794 23.4393 22.5607C23.7206 22.842 24.1022 23 24.5 23C24.8978 23 25.2794 22.842 25.5607 22.5607Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.5 12C26.16 12 26.72 12.42 26.92 13.01L29 19V27C29 27.55 28.55 28 28 28H27C26.45 28 26 27.55 26 27V26H14V27C14 27.55 13.55 28 13 28H12C11.45 28 11 27.55 11 27V19L13.08 13.01C13.29 12.42 13.84 12 14.5 12H25.5ZM25.14 14H14.85L13.77 17.11H26.22L25.14 14ZM13 24H27V19H13V24Z"
        fill="black"
      />
    </svg>
  )
}

export default SvgCarFrontIcon
